import React from 'react';
import {Button, Col, ColorPicker, Divider, message, Row, theme} from 'antd';
import type {ColorPickerProps} from 'antd';
import {generate, green, presetPalettes, red, cyan} from '@ant-design/colors';
import {Color} from 'antd/es/color-picker';
import {BgColorsOutlined} from '@ant-design/icons';

type Presets = Required<ColorPickerProps>['presets'][number];

const genPresets = (presets = presetPalettes) =>
    Object.entries(presets).map<Presets>(([label, colors]) => ({
        label,
        colors,
    }));

interface EyeColorProps {
    sRGBHex: string;
}

interface Props {
    value?: string;
    onChange?: (value: string) => void;
}
const Index = ({value, onChange}: Props) => {
    const {token} = theme.useToken();

    const presets = genPresets({
        primary: generate(token.colorPrimary),
        red,
        green,
        cyan,
    });

    const customPanelRender: ColorPickerProps['panelRender'] = (
        _,
        {components: {Picker, Presets}},
    ) => (
        <Row justify="space-between" wrap={false}>
            <Col span={12}>
                <Presets />
                <Button
                    style={{marginTop: 10}}
                    icon={<BgColorsOutlined />}
                    onClick={onEyeDrop}>
                    启动吸管
                </Button>
            </Col>
            <Divider type="vertical" style={{height: 'auto'}} />
            <Col flex="auto">
                <Picker />
            </Col>
        </Row>
    );

    function onSelect(color: Color, hex: string) {
        onChange?.(hex);
    }

    function onEyeDrop() {
        // @ts-ignore
        if (!window.EyeDropper) {
            message.error('你的浏览器不支持 EyeDropper API');
            return;
        }
        // @ts-ignore //实验性特性
        const eyeDropper = new EyeDropper();
        eyeDropper.open().then((result: EyeColorProps) => {
            onChange?.(result.sRGBHex);
        });
    }

    return (
        <ColorPicker
            value={value}
            onChange={(color, hex) => onSelect(color, hex)}
            styles={{popupOverlayInner: {width: 520}}}
            presets={presets}
            panelRender={customPanelRender}
        />
    );
};

export default Index;
